//Import Dependencies
import * as React from 'react';
import Popover from 'antd/lib/popover';
import Table from 'antd/lib/table';
import {
  CardLight
} from 'one-ui-card/src/card-light';
import {
  CardNoData,
} from 'one-ui-card';
import {
  InsuranceCardProps,
} from './props';
import InformationOutline from "@2fd/ant-design-icons/lib/InformationOutline";
import Skeleton from 'antd/lib/skeleton';
import {
  checkCardHasError,
  CardErrorMsg,
  CardLockIcon
} from 'one-card-notification';
import { useCtx } from "one-ui-provider";
/**
 * This function returns all the insurance
 * @param props has all input parameters to load the Card
 * @returns JSX code for Insurance
 */
export const InsuranceCard = (
  props: InsuranceCardProps
) => {
  const {
    insurance,
    skeleton,
  } = props;
  const {
    insurance_skeleton
  } = skeleton;
  const { settings } = useCtx();
  const { uisettings: { dashboardcardconfig } } = settings;
  // set default screen on intital/reset screen
  let insuranceresult = (
    <div></div>
  );


  let data: any = [];
  // If Insurance skeleton is true
  if (insurance_skeleton) {
    insuranceresult = (<Skeleton active paragraph={{ rows: 2 }} />);
  }
  //Insurance Table columns
  const columns = [
    {
      title: () => (<span style={{ paddingLeft: "1.1rem" }}>Plan</span>),
      dataIndex: 'info',
      key: 's1',
      render: (data: any) => {
        return (
          <>{data.plan}</>
        )
      },
      width: '100%'
    },
    {
      title: 'Group Number',
      dataIndex: 'info',
      key: 's2',
      render: (data: any) => {
        const content = (
          <>
            <div className="text-base text-black-85 font-medium mb-5">{data.plan}</div>
            {data.list.map((value: any, index: any) => {
              return <div className="text-sm text-black-40" key={index}>{value.title}: <span className="text-black-85">{value.note}</span></div>
            })}
          </>
        );
        return (
          <div className="flex">
            {data.groupnumber}
            <Popover placement="top" content={content} trigger="hover">
              <InformationOutline className="text-lg ml-5" />
            </Popover>
          </div>
        )
      }
    }
  ]
  //Check if the response is available
  if (insurance?.values?.length > 0) {
    insurance?.values.map((insuredata: any) => {
      insuredata?.insurancedetails.map((moredetails: any) => {
        let infodata =
        {
          info: {
            plan: insuredata.planname ? insuredata.planname : "",
            groupnumber: insuredata.groupnumber ? insuredata.groupnumber : "",
            list: [
              {
                title: "Coverage Type",
                note: moredetails.coveragetype ? moredetails.coveragetype : "",
              },
              {
                title: "Effective From",
                note: moredetails.effectivefromdate ? moredetails.effectivefromdate : "",
              },
              {
                title: "Effective To",
                note: moredetails.effectivetodate ? moredetails.effectivetodate : "",
              },
              {
                title: "Product Type",
                note: moredetails.producttype ? moredetails.producttype : "",
              }
            ]
          }
        }
        data.push(infodata);
      })
    })
    insuranceresult = (
      <>
        <Table
          className="ant-table--smaller"
          columns={columns}
          dataSource={data}
          pagination={false}
        />
      </>
    )
  }

  //Check for No Data
  if (insurance?.values?.length == 0 && ('selected' in insurance) && insurance?.selected === undefined) {
    insuranceresult = (
      <>
        <CardNoData />
      </>
    );
  }
//Check for any error in rendering.
  if(checkCardHasError('Insurance') && 
    (insurance?.values?.length == 0 && ('selected' in insurance) && insurance?.selected === undefined)){
    insuranceresult = 
      <>
        <CardErrorMsg />
      </>
  }
  // Based on insuranceDetails flag If insuranceDetails flag set as false then Lock Icon Will Show
  if (!dashboardcardconfig?.insuranceDetails){
    insuranceresult = 
    <>
        <CardLockIcon />
    </>
  }


  return (
    <CardLight
      title="Insurance Details"
      body={
        insuranceresult
      }
    />
  );
};
